import { Chrono as ChronoComponent } from './Chrono.component';
import { connector } from './Chrono.connector';

export const Chrono = connector(ChronoComponent);
